import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

/**
 * @purpose Edit one actor that can execute transitions
 * @primary Entity form
 * @persona danilo-tech
 */
export const Route = createFileRoute("/app/admin/fsm-workflows/entities/$id")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
